export default __webpack_public_path__ + "static/media/us-hi.3d509d27.svg";